module.exports = __webpack_public_path__ + "img/evaluation.2b2bd66f.svg";